import { Directive, EventEmitter, Output } from '@angular/core';

@Directive()
export abstract class BaseFilterComponent {
    @Output()
    abstract filterChanged: EventEmitter<void>;
}
